module.exports = __webpack_public_path__ + "static/media/white-add.296a8d54.svg";